// SEO utility functions for managing Schema.org JSON-LD

export const injectSchemaOrg = (schemaData: object) => {
  // Remove existing schema if present
  const existingSchema = document.querySelector('script[type="application/ld+json"]');
  if (existingSchema) {
    existingSchema.remove();
  }

  // Create and inject new schema
  const script = document.createElement('script');
  script.type = 'application/ld+json';
  script.text = JSON.stringify(schemaData);
  document.head.appendChild(script);
};

export const getOrganizationSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://freeworkers.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Freeworkers',
    url: siteUrl,
    logo: 'https://static.readdy.ai/image/d59b18a86b2c4da172af70cd0d419253/e7f50c5a512809dd1b1927e02624ebd4.png',
    description: 'AI 챗봇 개발, 업무 프로세스 자동화, AI 데이터 분석 등 맞춤형 AI 솔루션을 제공하는 전문 기업',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'Customer Service',
      availableLanguage: ['Korean', 'English']
    },
    sameAs: []
  };
};

export const getWebPageSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://freeworkers.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'Freeworkers - AI 자동화로 비즈니스 혁신',
    description: 'AI 챗봇 개발, 업무 프로세스 자동화, AI 데이터 분석 등 맞춤형 AI 솔루션을 제공합니다.',
    url: siteUrl,
    inLanguage: 'ko',
    isPartOf: {
      '@type': 'WebSite',
      name: 'Freeworkers',
      url: siteUrl
    }
  };
};

export const getServiceSchema = () => {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://freeworkers.com';
  
  return {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'AI Automation Services',
    provider: {
      '@type': 'Organization',
      name: 'Freeworkers',
      url: siteUrl
    },
    areaServed: 'KR',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'AI 자동화 서비스',
      itemListElement: [
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'AI 챗봇 개발',
            description: '고객 응대부터 내부 업무 지원까지, 24/7 작동하는 지능형 챗봇으로 고객 경험을 혁신합니다'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '업무 프로세스 자동화',
            description: '반복적인 수작업을 AI로 자동화하여 직원들이 더 가치 있는 업무에 집중할 수 있도록 지원합니다'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: 'AI 데이터 분석',
            description: '방대한 데이터에서 인사이트를 추출하고, 비즈니스 의사결정을 위한 예측 분석을 제공합니다'
          }
        },
        {
          '@type': 'Offer',
          itemOffered: {
            '@type': 'Service',
            name: '맞춤형 AI 솔루션',
            description: '귀사의 특정 요구사항에 맞춘 AI 솔루션을 설계하고 구축하여 경쟁 우위를 확보합니다'
          }
        }
      ]
    }
  };
};

export const getAggregateRatingSchema = () => {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Freeworkers',
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '4.9',
      reviewCount: '500',
      bestRating: '5',
      worstRating: '1'
    }
  };
};
